import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** DateTime */
  DateTimeUtc: any;
  Datetime: any;
  /** NaiveDate */
  NaiveDate: any;
  SessionItemKey: any;
  SessionItemValue: any;
  UUID: any;
  /** Url */
  Url: any;
  /** Uuid */
  Uuid: any;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  line1: Scalars['String'];
  line2: Scalars['String'];
  state: Scalars['String'];
  stateCode: Scalars['String'];
  zipCode: Scalars['String'];
};

export type Amount = {
  __typename?: 'Amount';
  amount: Scalars['String'];
  amountTimePeriod: Scalars['String'];
  amountTimePeriodCode: Scalars['String'];
  authorizationRequired: Scalars['Boolean'];
  level: Scalars['String'];
  levelCode: Scalars['String'];
  payerNotes?: Maybe<Array<Scalars['String']>>;
  remaining: Scalars['String'];
  remainingTimePeriod: Scalars['String'];
  remainingTimePeriodCode: Scalars['String'];
  total: Scalars['String'];
  totalTimePeriod: Scalars['String'];
  totalTimePeriodCode: Scalars['String'];
  units: Scalars['String'];
};

export type Amounts = {
  __typename?: 'Amounts';
  deductibles: Deductibles;
  coPayment: CoPayment;
  coInsurance: CoInsurance;
  outOfPocket: OutOfPocket;
};

export type AvailityResult = {
  __typename?: 'AvailityResult';
  requestId: Scalars['String'];
  status: Scalars['String'];
  statusCode: Scalars['String'];
  remainingDeductible?: Maybe<Scalars['String']>;
  coInsurance?: Maybe<Scalars['String']>;
  remainingOutOfPocket?: Maybe<Scalars['String']>;
  isOutOfNetwork: Scalars['Boolean'];
};

export type Benefit = {
  __typename?: 'Benefit';
  name: Scalars['String'];
  type: Scalars['String'];
  status: Scalars['String'];
  statusCode: Scalars['String'];
  amounts?: Maybe<Amounts>;
};

export type BookingResult = {
  __typename?: 'BookingResult';
  isConfirmed: Scalars['Boolean'];
};

export type ChannelError = {
  __typename?: 'ChannelError';
  code: ChannelErrorCode;
};

export enum ChannelErrorCode {
  ChannelNotFound = 'CHANNEL_NOT_FOUND'
}

export type ChannelFilterInput = {
  id__in?: Maybe<Array<Scalars['UUID']>>;
};

export type ChannelFilterInputV2 = {
  id__in: Array<Scalars['UUID']>;
};

export type ChannelMutation = {
  __typename?: 'ChannelMutation';
  session: SessionMutation;
  sessionV2: SessionResponse;
};


export type ChannelMutationSessionArgs = {
  id?: Maybe<Scalars['UUID']>;
};


export type ChannelMutationSessionV2Args = {
  id?: Maybe<Scalars['UUID']>;
};

/**
 * Channel is a context of execution or environment for all requests. Context is defined by uuid.
 * There are uuids for production and staging environments
 */
export type ChannelQuery = {
  __typename?: 'ChannelQuery';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  sessions?: Maybe<Array<Maybe<SessionQuery>>>;
  sessionsV2: Array<SessionQuery>;
};


/**
 * Channel is a context of execution or environment for all requests. Context is defined by uuid.
 * There are uuids for production and staging environments
 */
export type ChannelQuerySessionsArgs = {
  pagination?: Maybe<PaginationInput>;
  filter?: Maybe<SessionFilterInput>;
};


/**
 * Channel is a context of execution or environment for all requests. Context is defined by uuid.
 * There are uuids for production and staging environments
 */
export type ChannelQuerySessionsV2Args = {
  pagination?: Maybe<PaginationInput>;
  filter: SessionFilterInputV2;
};

export type ChannelResponse = ChannelMutation | ChannelError;

export type CheckZipCodeSupportedError = {
  __typename?: 'CheckZipCodeSupportedError';
  code: CheckZipCodeSupportedErrorCode;
};

export enum CheckZipCodeSupportedErrorCode {
  NoSessionSet = 'NO_SESSION_SET',
  ZipCodeMissing = 'ZIP_CODE_MISSING'
}

export type CheckZipCodeSupportedResponse = CheckZipCodeSupportedResult | CheckZipCodeSupportedError;

export type CheckZipCodeSupportedResult = {
  __typename?: 'CheckZipCodeSupportedResult';
  isSupported: Scalars['Boolean'];
};

export type CoInsurance = {
  __typename?: 'CoInsurance';
  inNetwork?: Maybe<Array<Amount>>;
  outOfNetwork?: Maybe<Array<Amount>>;
};

export type CoPayment = {
  __typename?: 'CoPayment';
  inNetwork?: Maybe<Array<Amount>>;
  outOfNetwork?: Maybe<Array<Amount>>;
};

export type ConfirmBookingError = {
  __typename?: 'ConfirmBookingError';
  code: ConfirmBookingErrorCode;
};

export enum ConfirmBookingErrorCode {
  NoSessionSet = 'NO_SESSION_SET',
  DateTimeParsingFailed = 'DATE_TIME_PARSING_FAILED'
}

export type ConfirmBookingResponse = BookingResult | ConfirmBookingError | MissingFieldsError;

export type CoverageIds = {
  __typename?: 'CoverageIds';
  ids: Array<Scalars['String']>;
};

export type CreateLeadError = {
  __typename?: 'CreateLeadError';
  code: CreateLeadErrorCode;
};

export enum CreateLeadErrorCode {
  CreateLeadFirstNameIsEmpty = 'CREATE_LEAD_FIRST_NAME_IS_EMPTY',
  CreateLeadLastNameIsEmpty = 'CREATE_LEAD_LAST_NAME_IS_EMPTY'
}

export type CreateLeadInput = {
  zipCode: Scalars['String'];
  parentName: ParentName;
  email: Scalars['String'];
  phone: Scalars['String'];
  /** range of years semi free form */
  age: Scalars['String'];
  diagnosis?: Maybe<Lead_Has_Diagnosis>;
  /** skip is none */
  hasInsurance?: Maybe<Lead_Has_Insurance>;
  /** if has_insurance == Yes, than this is Some */
  insurance?: Maybe<InsuranceInput>;
  landingPage?: Maybe<Scalars['Url']>;
  firstTouchUrl?: Maybe<Scalars['Url']>;
  /** best effort of frontend to use client time to get UTC time */
  firstTouchDate: Scalars['DateTimeUtc'];
  smsOptOut?: Maybe<Scalars['Boolean']>;
  utmParameters?: Maybe<UtmParametersInput>;
  /** produced from ad tracking, marketing attribution and UTM ids */
  leadSource: Lead_Source;
  sessionId: Scalars['Uuid'];
};

export type CreateLeadResponse = CreateLeadResult | CreateLeadError;

export type CreateLeadResult = {
  __typename?: 'CreateLeadResult';
  createdAt: Scalars['DateTimeUtc'];
  leadId: Scalars['String'];
};



export type Deductibles = {
  __typename?: 'Deductibles';
  inNetwork?: Maybe<Array<Amount>>;
  outOfNetwork?: Maybe<Array<Amount>>;
};

export type InitResponse = CoverageIds | MissingFieldsError | ParentNameError;

export type InsuranceCoverageReportError = {
  __typename?: 'InsuranceCoverageReportError';
  code: InsuranceCoverageReportErrorCode;
};

export enum InsuranceCoverageReportErrorCode {
  NoSessionSet = 'NO_SESSION_SET'
}

export type InsuranceCoverageReportFilterInput = {
  id__in?: Maybe<Array<Scalars['String']>>;
};

export type InsuranceCoverageReportMutation = {
  __typename?: 'InsuranceCoverageReportMutation';
  /**
   * Initiates preparation of coverage report.
   * Session should contain those parameters:
   * INSURANCE_PAYER_ID
   * INSURANCE_PROVIDER_NPI
   * INSURANCE_SERVICE_TYPE
   * INSURANCE_MEMBER_ID
   * PARENT_NAME
   * PARENT_DOB
   * Report preparation progress and results could be checked by insurance_coverage_reports query
   */
  init?: Maybe<Array<Scalars['String']>>;
  initV2: InitResponse;
};

export type InsuranceCoverageReportQuery = {
  __typename?: 'InsuranceCoverageReportQuery';
  id: Scalars['String'];
  status: Scalars['String'];
  statusCode: Scalars['String'];
  patient: Patient;
  subscriber: Subscriber;
  payer: Payer;
  plans?: Maybe<Array<Plan>>;
  validationMessages?: Maybe<Array<Scalars['String']>>;
};

export type InsuranceCoverageReportResponse = InsuranceCoverageReportMutation | InsuranceCoverageReportError;

export type InsuranceInput = {
  insuranceCompany?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  payerId?: Maybe<Scalars['String']>;
  insuredDateOfBirth?: Maybe<Scalars['NaiveDate']>;
};

export type IsSupportedZipCodeResponse = {
  __typename?: 'IsSupportedZipCodeResponse';
  isSupported?: Maybe<Scalars['Boolean']>;
};

export type ItemSetError = {
  __typename?: 'ItemSetError';
  code: ItemSetErrorCode;
};

export enum ItemSetErrorCode {
  NoSessionSet = 'NO_SESSION_SET'
}

export type ItemSetResponse = ItemSetResult | ItemSetError;

export type ItemSetResult = {
  __typename?: 'ItemSetResult';
  result: Scalars['Boolean'];
};

export enum Lead_Has_Diagnosis {
  LeadHasDiagnosisYes = 'LEAD_HAS_DIAGNOSIS_YES',
  LeadHasDiagnosisNo = 'LEAD_HAS_DIAGNOSIS_NO',
  LeadHasDiagnosisUnknown = 'LEAD_HAS_DIAGNOSIS_UNKNOWN'
}

export enum Lead_Has_Insurance {
  LeadHasInsuranceYes = 'LEAD_HAS_INSURANCE_YES',
  LeadHasInsuranceNo = 'LEAD_HAS_INSURANCE_NO'
}

export enum Lead_Source {
  LeadSourceFacebook = 'LEAD_SOURCE_FACEBOOK',
  LeadSourceGoogleAds = 'LEAD_SOURCE_GOOGLE_ADS',
  LeadSourceGoogleOrganic = 'LEAD_SOURCE_GOOGLE_ORGANIC',
  /** including My Business */
  LeadSourceGoogleMaps = 'LEAD_SOURCE_GOOGLE_MAPS',
  LeadSourceBingOrganic = 'LEAD_SOURCE_BING_ORGANIC',
  LeadSourcePartner = 'LEAD_SOURCE_PARTNER',
  LeadSourceTest = 'LEAD_SOURCE_TEST',
  LeadSourceFacebookPaid = 'LEAD_SOURCE_FACEBOOK_PAID',
  LeadSourceDirect = 'LEAD_SOURCE_DIRECT',
  LeadSourceOther = 'LEAD_SOURCE_OTHER'
}

export type MedicalDocument = {
  __typename?: 'MedicalDocument';
  fileName: Scalars['String'];
  size: Scalars['Int'];
  url: Scalars['String'];
};

export type MissingFieldsError = {
  __typename?: 'MissingFieldsError';
  code: MissingFieldsErrorCode;
  fields: Array<Scalars['String']>;
};

export enum MissingFieldsErrorCode {
  MissingFields = 'MISSING_FIELDS'
}

export type Mutation = {
  __typename?: 'Mutation';
  channel?: Maybe<ChannelMutation>;
  channelV2: ChannelResponse;
  zipCode: ZipCodeMutation;
  createLead: CreateLeadResponse;
  updateLead: UpdateLeadResponse;
};


export type MutationChannelArgs = {
  id: Scalars['UUID'];
};


export type MutationChannelV2Args = {
  id: Scalars['UUID'];
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


export type OutOfPocket = {
  __typename?: 'OutOfPocket';
  inNetwork?: Maybe<Array<Amount>>;
  outOfNetwork?: Maybe<Array<Amount>>;
};

export type PaginationInput = {
  offset: Scalars['Int'];
  count: Scalars['Int'];
};

export type ParentName = {
  first: Scalars['String'];
  last: Scalars['String'];
};

export type ParentNameError = {
  __typename?: 'ParentNameError';
  code: ParentNameErrorCode;
  parentName: Scalars['String'];
};

export enum ParentNameErrorCode {
  ParentNameParsingFailed = 'PARENT_NAME_PARSING_FAILED'
}

export type Patient = {
  __typename?: 'Patient';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: Scalars['String'];
  genderCode: Scalars['String'];
  birthDate: Scalars['String'];
  address: Address;
};

export type Payer = {
  __typename?: 'Payer';
  name: Scalars['String'];
  payerId: Scalars['String'];
  responseName: Scalars['String'];
  responsePayerId: Scalars['String'];
};

export type PayerNote = {
  __typename?: 'PayerNote';
  message: Scalars['String'];
  type: Scalars['String'];
  typeCode: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  groupName: Scalars['String'];
  groupNumber: Scalars['String'];
  insuranceType: Scalars['String'];
  insuranceTypeCode: Scalars['String'];
  payerNotes?: Maybe<Array<PayerNote>>;
  status: Scalars['String'];
  statusCode: Scalars['String'];
  benefits?: Maybe<Array<Benefit>>;
  coverageStartDate: Scalars['String'];
  coverageEndDate: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  channels?: Maybe<Array<ChannelQuery>>;
  channelsV2: Array<ChannelQuery>;
  current_time_utc: Scalars['String'];
};


export type QueryChannelsArgs = {
  pagination?: Maybe<PaginationInput>;
  filter?: Maybe<ChannelFilterInput>;
};


export type QueryChannelsV2Args = {
  pagination?: Maybe<PaginationInput>;
  filter: ChannelFilterInputV2;
};

export type Score = {
  __typename?: 'Score';
  value: Scalars['Int'];
};

export type ScreenerScoreError = {
  __typename?: 'ScreenerScoreError';
  code: ScreenerScoreErrorCode;
};

export enum ScreenerScoreErrorCode {
  NoAnswersInSession = 'NO_ANSWERS_IN_SESSION'
}

export type ScreenerScoreResponse = Score | ScreenerScoreError;

export type SessionError = {
  __typename?: 'SessionError';
  code: SessionErrorCode;
};

export enum SessionErrorCode {
  SessionNotFound = 'SESSION_NOT_FOUND'
}

export type SessionFilterInput = {
  id__in?: Maybe<Array<Scalars['UUID']>>;
};

export type SessionFilterInputV2 = {
  id__in: Array<Scalars['UUID']>;
};

export type SessionInitInput = {
  items?: Maybe<Array<SessionInitItemInput>>;
};

export type SessionInitItemInput = {
  key: Scalars['SessionItemKey'];
  value: Scalars['SessionItemValue'];
};

export type SessionItemFilterInput = {
  key__in?: Maybe<Array<Scalars['SessionItemKey']>>;
};


export type SessionItemMutation = {
  __typename?: 'SessionItemMutation';
  set: Scalars['Boolean'];
  setV2: ItemSetResponse;
};


export type SessionItemMutationSetArgs = {
  value: Scalars['SessionItemValue'];
};


export type SessionItemMutationSetV2Args = {
  value: Scalars['SessionItemValue'];
};

export type SessionItemQuery = {
  __typename?: 'SessionItemQuery';
  key?: Maybe<Scalars['SessionItemKey']>;
  value?: Maybe<Scalars['SessionItemValue']>;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with 'init' method. Data could be added with SessionItem 'set' method.
 */
export type SessionMutation = {
  __typename?: 'SessionMutation';
  init?: Maybe<SessionQuery>;
  item: SessionItemMutation;
  insuranceCoverageReport: InsuranceCoverageReportMutation;
  insuranceCoverageReportV2: InsuranceCoverageReportResponse;
  /**
   * Books time slot.
   * Session should contain those parameters:
   * SERVICE_ID
   * SUITABLE_PROVIDER_IDS
   * DATETIME
   * PARENT_NAME
   * EMAIL
   * PHONE
   * Optional session parameters:
   * BOOKING_TYPE
   * SERVICE_ID
   * SUITABLE_PROVIDER_IDS
   * DATETIME
   * TIMEZONE_OFFSET
   * TIME_ZONE_ABBREVIATION
   * PARENT_NAME
   * EMAIL
   * PHONE
   * CHILD_NAME
   * ZIP_CODE
   * CHILD_AGE
   * ASD_DIAGNOSIS
   * UTM
   * INSURANCE_MEMBER_ID
   * PARENT_DOB
   */
  bookingConfirm?: Maybe<Scalars['Boolean']>;
  /**
   * Books time slot.
   * Session should contain those parameters:
   * SERVICE_ID
   * SUITABLE_PROVIDER_IDS
   * DATETIME
   * PARENT_NAME
   * EMAIL
   * PHONE
   * Optional session parameters:
   * BOOKING_TYPE
   * SERVICE_ID
   * SUITABLE_PROVIDER_IDS
   * DATETIME
   * TIMEZONE_OFFSET
   * TIME_ZONE_ABBREVIATION
   * PARENT_NAME
   * EMAIL
   * PHONE
   * CHILD_NAME
   * ZIP_CODE
   * CHILD_AGE
   * ASD_DIAGNOSIS
   * UTM
   * INSURANCE_MEMBER_ID
   * PARENT_DOB
   */
  confirmBooking: ConfirmBookingResponse;
  bookingPay?: Maybe<Scalars['Boolean']>;
  /**
   * Creates report based on CAST screener answers
   * Optional session parameters
   * PARENT_NAME
   * EMAIL
   * PHONE
   * CHILD_NAME
   * SCORE
   */
  castCompleted?: Maybe<Scalars['Boolean']>;
  /**
   * Creates report based on CAST screener answers
   * Optional session parameters
   * PARENT_NAME
   * EMAIL
   * PHONE
   * CHILD_NAME
   * SCORE
   */
  setCastCompleted: SetScreenerCompletedResponse;
  /**
   * Creates report based on M-CHAT screener answers
   * Optional session parameters:
   * PARENT_NAME
   * EMAIL
   * PHONE
   * CHILD_NAME
   * SCORE
   */
  mchatrCompleted?: Maybe<Scalars['Boolean']>;
  /**
   * Creates report based on M-CHAT screener answers
   * Optional session parameters:
   * PARENT_NAME
   * EMAIL
   * PHONE
   * CHILD_NAME
   * SCORE
   */
  setMchatCompleted: SetScreenerCompletedResponse;
  uploadMedicalDocument: MedicalDocument;
  subscribe: Scalars['Boolean'];
  verifyInsurance?: Maybe<Scalars['Boolean']>;
  isSupportedZipCode?: Maybe<IsSupportedZipCodeResponse>;
  checkZipCodeSupported: CheckZipCodeSupportedResponse;
  unsupportedZipCode?: Maybe<Scalars['Boolean']>;
  notifyAboutUnsupportedZipCode: UnsupportedZipCodeResponse;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with 'init' method. Data could be added with SessionItem 'set' method.
 */
export type SessionMutationInitArgs = {
  input?: Maybe<SessionInitInput>;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with 'init' method. Data could be added with SessionItem 'set' method.
 */
export type SessionMutationItemArgs = {
  key: Scalars['SessionItemKey'];
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with 'init' method. Data could be added with SessionItem 'set' method.
 */
export type SessionMutationSubscribeArgs = {
  email: Scalars['String'];
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with 'init' method. Data could be added with SessionItem 'set' method.
 */
export type SessionMutationUnsupportedZipCodeArgs = {
  data: UnsupportedZipCodeInput;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with 'init' method. Data could be added with SessionItem 'set' method.
 */
export type SessionMutationNotifyAboutUnsupportedZipCodeArgs = {
  data: UnsupportedZipCodeInput;
};

/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with init method.
 */
export type SessionQuery = {
  __typename?: 'SessionQuery';
  id?: Maybe<Scalars['UUID']>;
  items?: Maybe<Array<Maybe<SessionItemQuery>>>;
  /**
   * Returns list of available provider time slots
   * Optional session parameters:
   * SERVICE_ID
   * SUITABLE_PROVIDER_IDS
   */
  timeSlots?: Maybe<Array<Maybe<TimeSlotQuery>>>;
  /**
   * Returns list of available provider time slots
   * Optional session parameters:
   * SERVICE_ID
   * SUITABLE_PROVIDER_IDS
   */
  timeSlotsV2: TimeSlotsResponse;
  /**
   * Returns status of coverage report preparation (In Progress, Complete, Error).
   * And report data if complete.
   */
  insuranceCoverageReports?: Maybe<Array<Maybe<InsuranceCoverageReportQuery>>>;
  mchatScore: ScreenerScoreResponse;
  castScore: ScreenerScoreResponse;
  insuranceCostsReport: AvailityResult;
  zipCodes?: Maybe<Array<ZipCodeQuery>>;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with init method.
 */
export type SessionQueryItemsArgs = {
  filter?: Maybe<SessionItemFilterInput>;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with init method.
 */
export type SessionQueryTimeSlotsArgs = {
  filter: TimeSlotFilterInput;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with init method.
 */
export type SessionQueryTimeSlotsV2Args = {
  filter: TimeSlotFilterInput;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with init method.
 */
export type SessionQueryInsuranceCoverageReportsArgs = {
  filter: InsuranceCoverageReportFilterInput;
};


/**
 * Session is user session and is intended to be used for storing session data.
 * Data could be read and written to session as long as session uuid is stored somewhere.
 * Session could be created with init method.
 */
export type SessionQueryInsuranceCostsReportArgs = {
  reportId: Scalars['String'];
};

export type SessionResponse = SessionMutation | SessionError;

export type SetScreenerCompletedError = {
  __typename?: 'SetScreenerCompletedError';
  code: SetScreenerCompletedErrorCode;
};

export enum SetScreenerCompletedErrorCode {
  NoSessionSet = 'NO_SESSION_SET',
  EmailMissing = 'EMAIL_MISSING',
  AnswersMissing = 'ANSWERS_MISSING'
}

export type SetScreenerCompletedResponse = SetScreenerCompletedResult | SetScreenerCompletedError | MissingFieldsError;

export type SetScreenerCompletedResult = {
  __typename?: 'SetScreenerCompletedResult';
  result: Scalars['Boolean'];
};

export type Subscriber = {
  __typename?: 'Subscriber';
  memberId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: Scalars['String'];
  genderCode: Scalars['String'];
  birthDate: Scalars['String'];
  address: Address;
};

export type TimeSlotFilterInput = {
  providerIds?: Maybe<Array<Scalars['String']>>;
  from: Scalars['Datetime'];
  to: Scalars['Datetime'];
};

export type TimeSlotQuery = {
  __typename?: 'TimeSlotQuery';
  datetime?: Maybe<Scalars['Datetime']>;
  providerIds?: Maybe<Array<Scalars['String']>>;
};

export type TimeSlots = {
  __typename?: 'TimeSlots';
  items: Array<TimeSlotQuery>;
};

export type TimeSlotsError = {
  __typename?: 'TimeSlotsError';
  code: TimeSlotsErrorCode;
};

export enum TimeSlotsErrorCode {
  FromAfterTo = 'FROM_AFTER_TO'
}

export type TimeSlotsResponse = TimeSlots | TimeSlotsError;


export type UnsupportedZipCodeError = {
  __typename?: 'UnsupportedZipCodeError';
  code: UnsupportedZipCodeErrorCode;
};

export enum UnsupportedZipCodeErrorCode {
  NoSessionSet = 'NO_SESSION_SET'
}

export type UnsupportedZipCodeInput = {
  name: Scalars['String'];
  zipCode: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type UnsupportedZipCodeResponse = UnsupportedZipCodeResult | UnsupportedZipCodeError;

export type UnsupportedZipCodeResult = {
  __typename?: 'UnsupportedZipCodeResult';
  result: Scalars['Boolean'];
};

export type UpdateLeadInput = {
  leadId: Scalars['String'];
  schedule?: Maybe<Scalars['String']>;
};

export type UpdateLeadResponse = UpdateLeadResult;

export type UpdateLeadResult = {
  __typename?: 'UpdateLeadResult';
  updatedAt: Scalars['DateTimeUtc'];
};


export type UtmParametersInput = {
  utmSource?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  gclid?: Maybe<Scalars['String']>;
  gclsrc?: Maybe<Scalars['String']>;
  fbclid?: Maybe<Scalars['String']>;
  keyword?: Maybe<Scalars['String']>;
  adGroup?: Maybe<Scalars['String']>;
};


export type ZipCodeIsSupportedInput = {
  zipCode: Scalars['String'];
};

export type ZipCodeIsSupportedResponse = ZipCodeIsSupportedResult;

export type ZipCodeIsSupportedResult = {
  __typename?: 'ZipCodeIsSupportedResult';
  value: Scalars['String'];
  isSupported: Scalars['Boolean'];
};

export type ZipCodeMutation = {
  __typename?: 'ZipCodeMutation';
  isSupported: ZipCodeIsSupportedResponse;
};


export type ZipCodeMutationIsSupportedArgs = {
  data: ZipCodeIsSupportedInput;
};

export type ZipCodeQuery = {
  __typename?: 'ZipCodeQuery';
  id?: Maybe<Scalars['UUID']>;
  value?: Maybe<Scalars['String']>;
};

export type CheckIfZipCodeIsSupportedMutationVariables = Exact<{
  data: ZipCodeIsSupportedInput;
}>;


export type CheckIfZipCodeIsSupportedMutation = (
  { __typename?: 'Mutation' }
  & { zipCode: (
    { __typename?: 'ZipCodeMutation' }
    & { isSupported: (
      { __typename: 'ZipCodeIsSupportedResult' }
      & Pick<ZipCodeIsSupportedResult, 'value' | 'isSupported'>
    ) }
  ) }
);

export type ConfirmBookingMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
}>;


export type ConfirmBookingMutation = (
  { __typename?: 'Mutation' }
  & { channel?: Maybe<(
    { __typename?: 'ChannelMutation' }
    & { session: (
      { __typename?: 'SessionMutation' }
      & Pick<SessionMutation, 'bookingConfirm'>
    ) }
  )> }
);

export type CreateLeadMutationVariables = Exact<{
  input: CreateLeadInput;
}>;


export type CreateLeadMutation = (
  { __typename?: 'Mutation' }
  & { createLead: (
    { __typename: 'CreateLeadResult' }
    & Pick<CreateLeadResult, 'createdAt' | 'leadId'>
  ) | (
    { __typename: 'CreateLeadError' }
    & Pick<CreateLeadError, 'code'>
  ) }
);

export type InitInsuranceCoverageReportMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
}>;


export type InitInsuranceCoverageReportMutation = (
  { __typename?: 'Mutation' }
  & { channelV2: (
    { __typename: 'ChannelMutation' }
    & { sessionV2: (
      { __typename: 'SessionMutation' }
      & { insuranceCoverageReportV2: (
        { __typename: 'InsuranceCoverageReportMutation' }
        & { initV2: (
          { __typename: 'CoverageIds' }
          & Pick<CoverageIds, 'ids'>
        ) | (
          { __typename: 'MissingFieldsError' }
          & { fieldsErrorCode: MissingFieldsError['code'] }
        ) | (
          { __typename: 'ParentNameError' }
          & { parentNameErrorCode: ParentNameError['code'] }
        ) }
      ) | (
        { __typename: 'InsuranceCoverageReportError' }
        & Pick<InsuranceCoverageReportError, 'code'>
      ) }
    ) | (
      { __typename: 'SessionError' }
      & Pick<SessionError, 'code'>
    ) }
  ) | (
    { __typename: 'ChannelError' }
    & Pick<ChannelError, 'code'>
  ) }
);

export type InitSessionMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  serviceId: Scalars['SessionItemValue'];
  providers: Scalars['SessionItemValue'];
}>;


export type InitSessionMutation = (
  { __typename?: 'Mutation' }
  & { channel?: Maybe<(
    { __typename?: 'ChannelMutation' }
    & { session: (
      { __typename?: 'SessionMutation' }
      & { init?: Maybe<(
        { __typename?: 'SessionQuery' }
        & Pick<SessionQuery, 'id'>
      )> }
    ) }
  )> }
);

export type IsSupportedZipCodeMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
}>;


export type IsSupportedZipCodeMutation = (
  { __typename?: 'Mutation' }
  & { channel?: Maybe<(
    { __typename?: 'ChannelMutation' }
    & { session: (
      { __typename?: 'SessionMutation' }
      & { isSupportedZipCode?: Maybe<(
        { __typename?: 'IsSupportedZipCodeResponse' }
        & Pick<IsSupportedZipCodeResponse, 'isSupported'>
      )> }
    ) }
  )> }
);

export type SetFieldValueMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
  field: Scalars['SessionItemKey'];
  value: Scalars['SessionItemValue'];
}>;


export type SetFieldValueMutation = (
  { __typename?: 'Mutation' }
  & { channelV2: (
    { __typename: 'ChannelMutation' }
    & { sessionV2: (
      { __typename: 'SessionMutation' }
      & { setValue: (
        { __typename?: 'SessionItemMutation' }
        & { setV2: (
          { __typename: 'ItemSetResult' }
          & Pick<ItemSetResult, 'result'>
        ) | (
          { __typename: 'ItemSetError' }
          & Pick<ItemSetError, 'code'>
        ) }
      ) }
    ) | (
      { __typename: 'SessionError' }
      & Pick<SessionError, 'code'>
    ) }
  ) | (
    { __typename: 'ChannelError' }
    & Pick<ChannelError, 'code'>
  ) }
);

export type SetZipCodeAndCheckIfItIsSupportedMutationVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
  zipCode: Scalars['SessionItemValue'];
}>;


export type SetZipCodeAndCheckIfItIsSupportedMutation = (
  { __typename?: 'Mutation' }
  & { channel?: Maybe<(
    { __typename?: 'ChannelMutation' }
    & { session: (
      { __typename?: 'SessionMutation' }
      & { item: (
        { __typename?: 'SessionItemMutation' }
        & Pick<SessionItemMutation, 'set'>
      ), isSupportedZipCode?: Maybe<(
        { __typename?: 'IsSupportedZipCodeResponse' }
        & Pick<IsSupportedZipCodeResponse, 'isSupported'>
      )> }
    ) }
  )> }
);

export type GetCurrentTimeUtcQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentTimeUtcQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'current_time_utc'>
);

export type GetAvailableTimeSlotsQueryVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
  fromDate: Scalars['Datetime'];
  toDate: Scalars['Datetime'];
}>;


export type GetAvailableTimeSlotsQuery = (
  { __typename?: 'Query' }
  & { channels?: Maybe<Array<(
    { __typename?: 'ChannelQuery' }
    & { sessions?: Maybe<Array<Maybe<(
      { __typename?: 'SessionQuery' }
      & { timeSlots?: Maybe<Array<Maybe<(
        { __typename?: 'TimeSlotQuery' }
        & Pick<TimeSlotQuery, 'datetime'>
      )>>> }
    )>>> }
  )>> }
);

export type GetInsuranceCostReportQueryVariables = Exact<{
  channelId: Scalars['UUID'];
  sessionId: Scalars['UUID'];
  reportId: Scalars['String'];
}>;


export type GetInsuranceCostReportQuery = (
  { __typename?: 'Query' }
  & { channelsV2: Array<(
    { __typename?: 'ChannelQuery' }
    & { sessionsV2: Array<(
      { __typename?: 'SessionQuery' }
      & { insuranceCostsReport: (
        { __typename?: 'AvailityResult' }
        & Pick<AvailityResult, 'requestId' | 'status' | 'statusCode' | 'remainingDeductible' | 'coInsurance' | 'remainingOutOfPocket' | 'isOutOfNetwork'>
      ) }
    )> }
  )> }
);


export const CheckIfZipCodeIsSupportedDocument = gql`
    mutation CheckIfZipCodeIsSupported($data: ZipCodeIsSupportedInput!) {
  zipCode {
    isSupported(data: $data) {
      __typename
      ... on ZipCodeIsSupportedResult {
        value
        isSupported
      }
    }
  }
}
    `;
export const ConfirmBookingDocument = gql`
    mutation ConfirmBooking($channelId: UUID!, $sessionId: UUID!) {
  channel(id: $channelId) {
    session(id: $sessionId) {
      bookingConfirm
    }
  }
}
    `;
export const CreateLeadDocument = gql`
    mutation CreateLead($input: CreateLeadInput!) {
  createLead(input: $input) {
    __typename
    ... on CreateLeadResult {
      createdAt
      leadId
    }
    ... on CreateLeadError {
      code
    }
  }
}
    `;
export const InitInsuranceCoverageReportDocument = gql`
    mutation InitInsuranceCoverageReport($channelId: UUID!, $sessionId: UUID!) {
  channelV2(id: $channelId) {
    __typename
    ... on ChannelMutation {
      sessionV2(id: $sessionId) {
        __typename
        ... on SessionMutation {
          insuranceCoverageReportV2 {
            __typename
            ... on InsuranceCoverageReportMutation {
              initV2 {
                __typename
                ... on CoverageIds {
                  ids
                }
                ... on MissingFieldsError {
                  fieldsErrorCode: code
                }
                ... on ParentNameError {
                  parentNameErrorCode: code
                }
              }
            }
            ... on InsuranceCoverageReportError {
              code
            }
          }
        }
        ... on SessionError {
          code
        }
      }
    }
    ... on ChannelError {
      code
    }
  }
}
    `;
export const InitSessionDocument = gql`
    mutation initSession($channelId: UUID!, $serviceId: SessionItemValue!, $providers: SessionItemValue!) {
  channel(id: $channelId) {
    session {
      init(
        input: {items: [{key: "SERVICE_ID", value: $serviceId}, {key: "SUITABLE_PROVIDER_IDS", value: $providers}]}
      ) {
        id
      }
    }
  }
}
    `;
export const IsSupportedZipCodeDocument = gql`
    mutation isSupportedZipCode($channelId: UUID!, $sessionId: UUID!) {
  channel(id: $channelId) {
    session(id: $sessionId) {
      isSupportedZipCode {
        isSupported
      }
    }
  }
}
    `;
export const SetFieldValueDocument = gql`
    mutation SetFieldValue($channelId: UUID!, $sessionId: UUID!, $field: SessionItemKey!, $value: SessionItemValue!) {
  channelV2(id: $channelId) {
    __typename
    ... on ChannelMutation {
      sessionV2(id: $sessionId) {
        __typename
        ... on SessionMutation {
          setValue: item(key: $field) {
            setV2(value: $value) {
              __typename
              ... on ItemSetResult {
                result
              }
              ... on ItemSetError {
                code
              }
            }
          }
        }
        ... on SessionError {
          code
        }
      }
    }
    ... on ChannelError {
      code
    }
  }
}
    `;
export const SetZipCodeAndCheckIfItIsSupportedDocument = gql`
    mutation setZipCodeAndCheckIfItIsSupported($channelId: UUID!, $sessionId: UUID!, $zipCode: SessionItemValue!) {
  channel(id: $channelId) {
    session(id: $sessionId) {
      item(key: "ZIP_CODE") {
        set(value: $zipCode)
      }
      isSupportedZipCode {
        isSupported
      }
    }
  }
}
    `;
export const GetCurrentTimeUtcDocument = gql`
    query GetCurrentTimeUtc {
  current_time_utc
}
    `;
export const GetAvailableTimeSlotsDocument = gql`
    query GetAvailableTimeSlots($channelId: UUID!, $sessionId: UUID!, $fromDate: Datetime!, $toDate: Datetime!) {
  channels(filter: {id__in: [$channelId]}) {
    sessions(filter: {id__in: [$sessionId]}) {
      timeSlots(filter: {from: $fromDate, to: $toDate}) {
        datetime
      }
    }
  }
}
    `;
export const GetInsuranceCostReportDocument = gql`
    query GetInsuranceCostReport($channelId: UUID!, $sessionId: UUID!, $reportId: String!) {
  channelsV2(filter: {id__in: [$channelId]}) {
    sessionsV2(filter: {id__in: [$sessionId]}) {
      insuranceCostsReport(reportId: $reportId) {
        requestId
        status
        statusCode
        remainingDeductible
        coInsurance
        remainingOutOfPocket
        isOutOfNetwork
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CheckIfZipCodeIsSupported(variables: CheckIfZipCodeIsSupportedMutationVariables, requestHeaders?: Headers): Promise<CheckIfZipCodeIsSupportedMutation> {
      return withWrapper(() => client.request<CheckIfZipCodeIsSupportedMutation>(print(CheckIfZipCodeIsSupportedDocument), variables, requestHeaders));
    },
    ConfirmBooking(variables: ConfirmBookingMutationVariables, requestHeaders?: Headers): Promise<ConfirmBookingMutation> {
      return withWrapper(() => client.request<ConfirmBookingMutation>(print(ConfirmBookingDocument), variables, requestHeaders));
    },
    CreateLead(variables: CreateLeadMutationVariables, requestHeaders?: Headers): Promise<CreateLeadMutation> {
      return withWrapper(() => client.request<CreateLeadMutation>(print(CreateLeadDocument), variables, requestHeaders));
    },
    InitInsuranceCoverageReport(variables: InitInsuranceCoverageReportMutationVariables, requestHeaders?: Headers): Promise<InitInsuranceCoverageReportMutation> {
      return withWrapper(() => client.request<InitInsuranceCoverageReportMutation>(print(InitInsuranceCoverageReportDocument), variables, requestHeaders));
    },
    initSession(variables: InitSessionMutationVariables, requestHeaders?: Headers): Promise<InitSessionMutation> {
      return withWrapper(() => client.request<InitSessionMutation>(print(InitSessionDocument), variables, requestHeaders));
    },
    isSupportedZipCode(variables: IsSupportedZipCodeMutationVariables, requestHeaders?: Headers): Promise<IsSupportedZipCodeMutation> {
      return withWrapper(() => client.request<IsSupportedZipCodeMutation>(print(IsSupportedZipCodeDocument), variables, requestHeaders));
    },
    SetFieldValue(variables: SetFieldValueMutationVariables, requestHeaders?: Headers): Promise<SetFieldValueMutation> {
      return withWrapper(() => client.request<SetFieldValueMutation>(print(SetFieldValueDocument), variables, requestHeaders));
    },
    setZipCodeAndCheckIfItIsSupported(variables: SetZipCodeAndCheckIfItIsSupportedMutationVariables, requestHeaders?: Headers): Promise<SetZipCodeAndCheckIfItIsSupportedMutation> {
      return withWrapper(() => client.request<SetZipCodeAndCheckIfItIsSupportedMutation>(print(SetZipCodeAndCheckIfItIsSupportedDocument), variables, requestHeaders));
    },
    GetCurrentTimeUtc(variables?: GetCurrentTimeUtcQueryVariables, requestHeaders?: Headers): Promise<GetCurrentTimeUtcQuery> {
      return withWrapper(() => client.request<GetCurrentTimeUtcQuery>(print(GetCurrentTimeUtcDocument), variables, requestHeaders));
    },
    GetAvailableTimeSlots(variables: GetAvailableTimeSlotsQueryVariables, requestHeaders?: Headers): Promise<GetAvailableTimeSlotsQuery> {
      return withWrapper(() => client.request<GetAvailableTimeSlotsQuery>(print(GetAvailableTimeSlotsDocument), variables, requestHeaders));
    },
    GetInsuranceCostReport(variables: GetInsuranceCostReportQueryVariables, requestHeaders?: Headers): Promise<GetInsuranceCostReportQuery> {
      return withWrapper(() => client.request<GetInsuranceCostReportQuery>(print(GetInsuranceCostReportDocument), variables, requestHeaders));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;